module.exports = __webpack_public_path__ + "static/media/rock_climbing_ruins.59db8b20.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/game_icons/rock_climbing_ruins.png
// module id = 325
// module chunks = 0